<template>
  <ul class="filter-checkbox-list">
    <li
      v-for="option in options"
      :key="option.value"
      class="filter-checkbox-list__item"
    >
      <div class="option">
        <div
          :class="getIconBackgroudColor(option.icon.backgroundColor)"
          class="option__icon"
        >
          <BaseIcon
            :icon="option.icon.iconName"
            :colors="option.icon.iconColor"
            width="20px"
            height="20px"
            data-testid="option-icon"
          />
        </div>
        <Checkbox
          v-model="option.checked"
          class="option__checkbox"
          reverse
          @change="selectOption(option)"
        >
          {{ option.label }}
        </Checkbox>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import { BaseIcon, Checkbox } from '@warrenbrasil/nebraska-web';
import { IFilterQuickOptions } from '../../../../services/types/models/IFilters';

@Component({
  components: { Checkbox, BaseIcon }
})
export default class FilterCheckboxList extends Vue {
  @Prop({ type: Array, required: true })
  public options!: IFilterQuickOptions[];

  @Emit('select-option')
  selectOption(option: IFilterQuickOptions) {
    this.$forceUpdate();
    return option;
  }

  public getIconBackgroudColor(backgroundColor?: string) {
    return {
      'icon-red': backgroundColor === '#FFF2F5',
      'icon-blue': backgroundColor === '#E0F1FF',
      'icon-green': backgroundColor === '#D6FFE0'
    };
  }
}
</script>

<style lang="less" scoped>
.icon-red {
  background-color: #fff2f5;
}

.icon-blue {
  background-color: #e0f1ff;
}
.icon-green {
  background-color: #d6ffe0;
}

.option {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  &__icon {
    width: 32px;
    height: 32px;
    border-radius: 100px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
  }

  &__checkbox {
    width: 100%;
    justify-content: space-between;
  }
}

.filter-checkbox-list {
  list-style: none;
  padding: 0;

  &__item {
    display: flex;

    ::v-deep > label {
      justify-content: space-between;
      flex: 1;
    }
  }
}
</style>
